<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.unidade"
        :disabled-button-search="true"
        ref="DataTable"
        sort-by="nomeFantasia"
        search-by="nomeFantasia"
    >
        <template v-slot:cell(cnpj)="row">
            {{ row.value | cnpj }}
        </template>

        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-unidade-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-cadastro-unidade"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-cadastro-unidade"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

export default {
    created() {

        this.repositories.unidade = this.getConectaSusRepository('cadastro.estabelecimento.unidade')
    },
    data: () => ({
        fields: [
            {
                name: 'cnes',
                key: 'cnes',
                label: 'CNES',
                searchable: true,
                sortable: true
            },
            {
                name: 'nomeFantasia',
                key: 'nomeFantasia',
                label: 'Nome Fantasia',
                searchable: true,
                sortable: true
            },
            {
                name: 'cnpj',
                key: 'cnpj',
                label: 'CNPJ',
                searchable: true,
                sortable: true
            },
            {
                name: 'gestor.cidadao.nome',
                key: 'gestor.cidadao.nome',
                label: 'Gestor',
                searchable: true,
                sortable: true
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        repositories: {
            unidade: null,
        },
    }),
    filters: {
        cnpj: formats.formatCnpj,
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.unidade.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o unidade?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>